let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("99Zz4")).then(() => parcelRequire('e5Htj'));